<style lang="scss" scoped>
</style>

<template>
  <c-layout>
    <!-- title -->
    <template #title>
      <div>Manage Users</div>
    </template>

    <!-- tool bar -->
    <template #toolbar>
      <div class="control pr-3">
        <input v-model="query" class="input" type="text" placeholder="Filter results...">
      </div>
      <button class="button" @click="drawer='create'">Create</button>
    </template>

    <!-- right side bar -->
    <template #drawer>

      <!-- create -->
      <c-drawer v-show="drawer" @close="drawer=null">
        <create-user-form v-show="drawer=='create'" @complete="drawer=null"/>
        <update-user-form v-if="drawer=='update'" :user="selected" @complete="drawer=null"/>
        <delete-user-form v-show="drawer=='delete'" :user="selected" @complete="drawer=null; selected=null;"/>
      </c-drawer>
    </template>

    <!-- main -->
    <template #content>

      <!-- user table -->
      <c-sorted-table :values="filtered" v-if="Object.values(filtered).length" class="table is-fullwidth">
        <thead>
          <tr>
            <th><c-sort-link name="email">Email</c-sort-link></th>
            <th style="width: 400px"><c-sort-link name="tag">Tag</c-sort-link></th>
            <th style="width: 150px"><c-sort-link name="role">Role</c-sort-link></th>
            <th style="width: 150px"><c-sort-link name="toc">Terms</c-sort-link></th>
            <th style="width: 300px"><c-sort-link name="created_at">Created</c-sort-link></th>
            <th style="width: 150px;"></th>
          </tr>
        </thead>
        <template #body="sort">
          <tbody>
            <tr v-for="user in sort.values" :key="user.id">
              <td>{{user.email | ifndef('-')}}</td>
              <td>{{user.tag | ifndef('-')}}</td>
              <td>{{user.role | ifndef('-')}}</td>
              <td>{{user.toc ? 'yes': 'no'}}</td>
              <td>{{user.created_at | datetime | local | ifndef('-')}}</td>
              <td>
                <a href="#" class="has-text-primary pr-3" @click.prevent="update(user)">edit</a>
                <a href="#" class="has-text-primary" @click.prevent="remove(user)">disable</a>
              </td>
            </tr>
          </tbody>
        </template>
      </c-sorted-table>

      <!-- no users banner -->
      <c-missing v-else>No users found.</c-missing>
    </template>

  </c-layout>
</template>

<script>
import matches from '@/utils/matches';
import api from '@/api';
import User from '@/models/user';
import CreateUserForm from './create-user-form';
import UpdateUserForm from './update-user-form';
import DeleteUserForm from './delete-user-form';


export default {
  name: 'manage-users',
  components: {
    CreateUserForm,
    UpdateUserForm,
    DeleteUserForm
  },
  data () {
    return {
      drawer: null,
      selected: null,
      query: ''
    };
  },
  created() {
    api.admin.users.load();
  },
  computed: {
    users: () => User.all(),
    filtered() {
      return this.users.filter(u => matches(u, ['email', 'tag'], this.query));
    }
  },
  methods: {
    update(user) {
      this.drawer = 'update';
      this.selected = user;
    },
    remove(user) {
      this.drawer = 'delete';
      this.selected = user;
    }
  }
};
</script>
